<template>
  <el-dialog
    :visible.sync="visible"
    width="360px"
    center
    custom-class="mobile-mini-program-dialog"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div slot="title" class="mobile-mini-program-dialog__title">
      <i class="el-icon-mobile-phone"></i>
      <span>移动端建议使用{{ miniProgramTitle }}</span>
    </div>
    <div class="mobile-mini-program-dialog__body">
      <p class="mobile-mini-program-dialog__desc">
        {{ isWechat ? '当前为微信内打开，建议优先进入微信小程序，操作更稳定、下载更方便。' : '当前为手机网页模式，部分下载和跳转体验不如微信小程序顺手。' }}
      </p>
      <div class="mobile-mini-program-dialog__tips">
        <div class="mobile-mini-program-dialog__tip">
          <i class="el-icon-info"></i>
          <span v-if="isWechat">可长按识别下方小程序码，或在微信中搜索“顶伯AI工具”。</span>
          <span v-else>可使用微信扫描下方小程序码，或在微信中搜索“顶伯AI工具”。</span>
        </div>
        <div class="mobile-mini-program-dialog__tip">
          <i class="el-icon-check"></i>
          <span>继续使用网页版也可以，不会影响当前访问。</span>
        </div>
      </div>
      <div class="mobile-mini-program-dialog__qr-wrap">
        <img class="mobile-mini-program-dialog__qr" :src="miniProgramQrImage" :alt="miniProgramTitle">
      </div>
    </div>
    <div slot="footer" class="mobile-mini-program-dialog__footer">
      <el-button @click="handleContinue">继续网页版</el-button>
      <el-button type="primary" @click="handleConfirm">
        {{ isWechat ? '我去微信里打开' : '我知道了' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  MINIPROGRAM_WIDGET_ENABLED,
  MINIPROGRAM_WIDGET_QR_IMAGE,
  MINIPROGRAM_WIDGET_TITLE
} from '@/config'

function isMobileViewport() {
  if (typeof window === 'undefined') return false
  return window.innerWidth <= 768
}

function isWechatBrowser() {
  if (typeof navigator === 'undefined') return false
  return /micromessenger/i.test(navigator.userAgent || '')
}

export default {
  name: 'MobileMiniProgramPrompt',
  data() {
    return {
      visible: false,
      isWechat: false
    }
  },
  computed: {
    miniProgramTitle() {
      return MINIPROGRAM_WIDGET_TITLE || '微信小程序'
    },
    miniProgramQrImage() {
      return MINIPROGRAM_WIDGET_QR_IMAGE
    }
  },
  mounted() {
    this.tryOpen()
  },
  methods: {
    tryOpen() {
      if (!MINIPROGRAM_WIDGET_ENABLED || !MINIPROGRAM_WIDGET_QR_IMAGE) return
      if (!isMobileViewport()) return
      this.isWechat = isWechatBrowser()
      this.visible = true
    },
    handleContinue() {
      this.visible = false
    },
    handleConfirm() {
      this.visible = false
    },
    handleClose() {
      this.visible = false
    }
  }
}
</script>

<style lang="less">
.mobile-mini-program-dialog {
  border-radius: 24px !important;
  overflow: hidden;
}

.mobile-mini-program-dialog .el-dialog__header {
  padding: 18px 18px 10px;
}

.mobile-mini-program-dialog .el-dialog__body {
  padding: 6px 18px 12px;
}

.mobile-mini-program-dialog .el-dialog__footer {
  padding: 8px 18px 18px;
}

.mobile-mini-program-dialog__title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  color: #303133;
}

.mobile-mini-program-dialog__title i {
  color: #409eff;
  font-size: 18px;
}

.mobile-mini-program-dialog__desc {
  margin: 0 0 12px;
  color: #4a5568;
  font-size: 14px;
  line-height: 1.7;
}

.mobile-mini-program-dialog__tips {
  display: grid;
  gap: 8px;
  margin-bottom: 14px;
}

.mobile-mini-program-dialog__tip {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 14px;
  background: linear-gradient(180deg, #f7fbff 0%, #edf5ff 100%);
  border: 1px solid rgba(64, 158, 255, 0.14);
  color: #5b6575;
  font-size: 13px;
  line-height: 1.6;
}

.mobile-mini-program-dialog__tip i {
  margin-top: 2px;
  color: #409eff;
}

.mobile-mini-program-dialog__qr-wrap {
  display: flex;
  justify-content: center;
  padding: 12px;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: inset 0 0 0 1px rgba(64, 158, 255, 0.08);
}

.mobile-mini-program-dialog__qr {
  display: block;
  width: 196px;
  max-width: 100%;
  border-radius: 16px;
}

.mobile-mini-program-dialog__footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.mobile-mini-program-dialog__footer .el-button {
  min-width: 120px;
  border-radius: 999px;
}

body.dark-mode-body .mobile-mini-program-dialog .el-dialog {
  background: var(--dialog-bg);
  border: 1px solid var(--border-color);
}

body.dark-mode-body .mobile-mini-program-dialog__title {
  color: var(--text-primary);
}

body.dark-mode-body .mobile-mini-program-dialog__desc {
  color: var(--text-regular);
}

body.dark-mode-body .mobile-mini-program-dialog__tip {
  background: rgba(64, 158, 255, 0.08);
  border-color: rgba(64, 158, 255, 0.16);
  color: var(--text-regular);
}

body.dark-mode-body .mobile-mini-program-dialog__qr-wrap {
  background: rgba(255, 255, 255, 0.03);
  box-shadow: inset 0 0 0 1px var(--border-color);
}
@media (max-width: 768px) {
  .mobile-mini-program-dialog {
    width: 92vw !important;
  }

  .mobile-mini-program-dialog__footer {
    flex-direction: column;
  }

  .mobile-mini-program-dialog__footer .el-button {
    width: 100%;
    margin: 0;
  }
}
</style>
